import React from 'react';
import { Box } from '@wds/box';
import { Button } from '@wds/button';
import { Grid } from '@wds/grid';
import { IconArrowRight } from '@wds/icons';
import { Typography } from '@wds/typography';
import { generateMetricsAttribute } from '@sm/metrics';
import { getSrc } from '~app/helpers/assetLoading';
import { getRewardsCTALink } from '~app/pages/SurveyThanks/utils';
import useUserAgent from '~app/hooks/useUserAgent';

export type OptionalPathCardProps = {
  image: string;
  imageAlt: string;
  header: string;
  subHeader: string;
  ctaType: 'taker' | 'creator';
  ctaText: string;
  templateType: string;
  surveyId: string;
  collectorId: string;
  respondentId: string;
  utSource: string;
  utSource2: string;
  utSource3: string;
  pathImageClass: string;
};

const OptionalPathCard = ({
  image,
  imageAlt,
  header,
  subHeader,
  ctaText,
  ctaType,
  templateType,
  surveyId,
  collectorId,
  respondentId,
  utSource,
  utSource2,
  utSource3,
  pathImageClass,
}: OptionalPathCardProps): React.ReactElement => {
  const userAgent = useUserAgent();

  // Conditionally set the amplitudeEvent based on ctaType
  const amplitudeEvent =
    ctaType === 'creator' ? 'optional paths survey creator cta' : 'optional paths survey contribute cta';

  const ctaLink = getRewardsCTALink(ctaType, utSource, utSource2, utSource3, ctaText, userAgent);

  return (
    <Grid.Item xl={6} lg={6} md={6} sm={12} xs={12}>
      <Box display="flex" flexJustify="center" alignItems="center" flexDirection="column">
        <img src={getSrc(image)} alt={imageAlt} className={pathImageClass} />
        <Box pt={4} pb={4}>
          <Box pb={5} display="flex" flexDirection="column" flexJustify="center">
            <Box pb={4}>
              <Typography variant="cardTitle" weight="medium" align="center" component="h4">
                {header}
              </Typography>
            </Box>
            <Typography component="span" align="center" variant="bodySm">
              {subHeader}
            </Typography>
          </Box>
          <Box display="flex" flexJustify="center">
            <Button
              size="lg"
              color={ctaType === 'taker' ? 'alt' : 'primary'}
              href={ctaLink}
              data-sm-metrics={generateMetricsAttribute({
                data: {
                  amplitudeEvent,
                  itemSelected: 'button',
                  templateType,
                  surveyId,
                  collectorId,
                  respondentId,
                  log: {
                    message: `${utSource}-${utSource2}-${utSource3}`,
                  },
                },
              })}
            >
              {ctaText}
              <Box ml={4}>
                <IconArrowRight title="arrow icon" />
              </Box>
            </Button>
          </Box>
        </Box>
      </Box>
    </Grid.Item>
  );
};

export default OptionalPathCard;
